module.exports = {
      id: "search-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "svg-sprite.svg#search",
      toString: function () {
        return this.url;
      }
    }